import { useLocation } from "react-router";
import { useMemo } from "react";
import { useSlideInMenu } from "../../components/slideInMenu/hooks/useSlideInMenu";
import { useCurrentCMSStream } from "../../hooks/useCurrentCMSStream";
import { resolveEngagementSource } from "../params/engagementSource";
import { getCurrentArea } from "../../screens/reader/hooks/readerNavigationArea";
import { ReaderNavigationContext } from "../../screens/reader/types";

export function useCurrentEngagementSource(
  options: Pick<ReaderNavigationContext, "trigger"> & {
    fallbackSource?: string;
  } = {},
): string {
  const location = useLocation();
  const { navigationContext } = useSlideInMenu();
  const routeArea = getCurrentArea(location.pathname, false);
  const stream = useCurrentCMSStream(routeArea);

  return useMemo(
    () =>
      resolveEngagementSource({
        pathname: location.pathname,
        slideInNavigationContext: navigationContext,
        trigger: options.trigger,
        streamId: stream?.id,
        streamSlug: stream?.slug,
        fallbackSource: options.fallbackSource,
      }),
    [
      location.pathname,
      navigationContext,
      options.trigger,
      options.fallbackSource,
      stream?.id,
      stream?.slug,
    ],
  );
}
